import React from "react";
import styles from "./styles/GameInfo.module.css";
import { formatTime, formatDate } from "../../util/util";
import { FaClock } from "react-icons/fa";
import { FaCalendar } from "react-icons/fa";
import useTranslation from "next-translate/useTranslation";
import { FaDiceSix } from "react-icons/fa";
import { FaBolt } from "react-icons/fa";
import { FaDragon } from "react-icons/fa";
import { BulletIcon } from "../../icons/BulletIcon";
import { VARIANT_CHESS960 } from "@chesshotel/constants";
import { useGamePlay } from "../../ducks/gamePlay";

export default function GameInfo() {
  const { variantId, startTime, startInc, date } = useGamePlay();
  const { t } = useTranslation("common");

  const timeStr = formatTime(startTime, startInc);
  const dateStr = formatDate(date);

  function formatGameType() {
    if (variantId === VARIANT_CHESS960) {
      return (
        <span className="inline-flex items-center space-x-1">
          <FaDiceSix /> <div>{t("Chess960")}</div>
        </span>
      );
    } else if (startTime < 3) {
      return (
        <span className="inline-flex items-center space-x-1">
          <BulletIcon /> <div>Bullet</div>
        </span>
      );
    } else if (startTime < 10) {
      return (
        <span className="inline-flex items-center space-x-1">
          <FaBolt />
          <div>Blitz</div>
        </span>
      );
    } else {
      return (
        <span className="inline-flex items-center space-x-1">
          <FaDragon /> <div>Rapid</div>
        </span>
      );
    }
  }

  return (
    <div className={styles.cont}>
      <div className={styles.row}>
        <div className={styles.gameType}>{formatGameType()}</div>
        <div className={styles.time}>
          <div className="flex items-center space-x-1">
            <FaClock /> <div>{timeStr}</div>
          </div>
        </div>
      </div>
      <div className=" border-b-2">
        <div className={styles.date}>
          <div className="flex items-center space-x-1">
            <FaCalendar /> <div>{dateStr}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
